import React, { useEffect } from 'react';
import { normalizeMediaUrl } from '../../utils/gameSchedule';
import { predictionRowName } from '../../utils/gamePredictions';

export function Modal({ label, onClose, className = '', children }) {
  useEffect(() => {
    const onKey = (event) => {
      if (event.key === 'Escape') onClose();
    };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [onClose]);
  return (
    <div className="games-modal" role="presentation" onClick={onClose}>
      <div
        className={`games-dialog ${className}`.trim()}
        role="dialog"
        aria-modal="true"
        aria-label={label}
        onClick={(event) => event.stopPropagation()}
      >
        {children}
      </div>
    </div>
  );
}

export function TeamMark({ name, logoUrl, className = '' }) {
  const uri = normalizeMediaUrl(logoUrl);
  return (
    <span className={`games-team ${className}`.trim()}>
      {uri ? <img src={uri} alt="" /> : <span className="games-logo-fallback" aria-hidden="true" />}
      <strong>{name || ''}</strong>
    </span>
  );
}

export function CheckIcon({ className = '' }) {
  return (
    <svg className={className} viewBox="0 0 16 16" aria-hidden="true">
      <path d="M3.5 8.5 6.5 11.5 12.5 5" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}

export function LockIcon() {
  return (
    <svg viewBox="0 0 16 16" aria-hidden="true">
      <rect x="3" y="7" width="10" height="7" rx="1.5" fill="none" stroke="currentColor" strokeWidth="1.4" />
      <path d="M5.2 7V5.2a2.8 2.8 0 0 1 5.6 0V7" fill="none" stroke="currentColor" strokeWidth="1.4" />
    </svg>
  );
}

export function ChevronRight() {
  return (
    <svg viewBox="0 0 16 16" aria-hidden="true">
      <path d="M6 3.5 10.5 8 6 12.5" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}

// A member's photo, and nothing at all without one, as the embed's rows do.
export function Avatar({ row, size = 32 }) {
  const uri = normalizeMediaUrl(row?.avatar_url || row?.avatarUrl || '');
  if (!uri) return null;
  return <img className="games-avatar" src={uri} alt="" style={{ width: size, height: size }} />;
}

// A person in a squad list: avatar, name ("You" for the fan), and whatever sits on the right.
export function PersonRow({ row, right, tag, lead }) {
  return (
    <li className={`games-person${row?.is_you ? ' is-you' : ''}`}>
      {lead}
      <Avatar row={row} />
      <span className="games-person-name">
        {predictionRowName(row)}
        {tag ? <em className="games-person-tag">{tag}</em> : null}
      </span>
      <span className="games-person-right">{right}</span>
    </li>
  );
}

const MEDALS = { 1: '#C4A46A', 2: '#C8C8C8', 3: '#A36A25' };

export function RankBadge({ rank }) {
  const n = Number(rank);
  if (!Number.isFinite(n) || n < 1) return <span className="games-rank-num" />;
  const medal = MEDALS[n];
  if (!medal) return <span className="games-rank-num">{n}</span>;
  return (
    <span className="games-medal" style={{ color: medal }}>
      <svg viewBox="0 0 20 24" aria-hidden="true">
        <path d="M10 1 18 4v8c0 5-3.4 8.6-8 11-4.6-2.4-8-6-8-11V4z" fill="currentColor" />
      </svg>
      <strong>{n}</strong>
    </span>
  );
}
